<script>
import DolCard from '../card/dol-card'
import showCode from "@/components/Dolphin-ant-design-erp/showCode";

export default {
  name: 'dol-list',
  components: {DolCard,showCode},
  props: {
    columns: {type: Array, default: () => []},              //列信息配置
    source: {type: String, default: 'server'},            //数据源，server | local
    //---------------------- if source === server --------------------------------//
    url: {type: String},                                  //后台地址
    method: {type: String, default: 'post'},              //请求方式
    queryData:{type: Object, default: () => {}},          //请求参数
    queryProperties: {type: Object, default: null},   //Java请求参数
    queryParams:{type: Object, default: () => {}},        //请求参数
    queryPathData:{type: Object, default: () => {}},      //请求参数
    serverType : {type: String, default: 'DotNet'},       //server类型，NodeJs, DotNet
    dotNetQueryType: {type: String, default: '1001'},     //dotNet接口
    dotNetTableType : {type: Number, default: 1},         //dotNet类型
    dotNetTableName : {},                                 //dotNet条件
    dotNetColumns : {type: Boolean, default: false},       //直接使用dotNet列
    dotNetDefaultSortField : {type: String, default: 'UPDATE_DATE'},  //默认排序字段
    dotNetFormatFlag : {type: Boolean, default: true},    //重新拼装dotNet请求结构
    dotNetReturnListField : {type: String, default: "DATA_LIST"},    //重新拼装dotNet请求结构
    initDataFlag: {type: Boolean, default: true},         //默认是否请求一次数据
    //---------------------- if source === local  --------------------------------//
    defaultData: {
      type: Array, default: function () {
        return [];
      }
    },                     //后台地址

    pagination: {type: Boolean, default: true},            //是否带分页
    //---------------------- if pagination === true --------------------------------//
    paginationType: {type: String, default: 'server'},            //分页类型：前台分页 / 后面分页
    defaultPageSize: {type: Number, default: 10},                                        //每页条数
    defaultPageNumber: {type: Number, default: 1},                                       //当前页数
    pageSizeOption: {
      type: Array, default: function () {
        return ['5', '10', '20', '50', '100']
      }
    },  //可选每页条数
    paginationShowSizeChanger: {Boolean, default: true},
    paginationShowQuickJumper: {Boolean, default: true},
    paginationShowTotal: {Boolean, default: true},

    size: {type: String, default: 'middle'},
    bordered: {type: Boolean, default: false},
    title: {type: String, default: '列表'},
    titleFlag: {type: Boolean, default: true},
    showHeader: {type: Boolean, default: true},
    loading: {type: Boolean, default: true},

    cardFlag: {type: Boolean, default: true},
    cardClass: {type: String, default: null},
    rowKey: {type: String, default: '_id'},
    scrollX: {default: null},
    scrollY: {default: null},
    scroll: {type: Object},

    selectedRowKeys: {type: Array, default: null},
    selectedRows: {type: Array, default: null},
    selectionGetCheckboxProps: {type: Function, default: null},
    selectionType: {type: String, default: null},
    defaultExpandAllRows: {type: Boolean, default: false},
    rowIndex: {type: Boolean, default: false},

    hideDetailButton: {type: Boolean, default: false},
    hideEditButton: {type: Boolean, default: false},
    hideDeleteButton: {type: Boolean, default: true},

    customRow: {type: Function, default: null},
  },
  data: function () {
    let params = {
      serverData: {rows: [], total: 0},
      pageSize: this.defaultPageSize,
      pageNumber: this.defaultPageNumber,
      checkedData: [],
      pageSorter: null,

      loadingFlag: false,
      innerColumns: [],
    };
    return params;
  },
  computed: {
    radioFlag() {
      return !this.multiple;
    },
    tableData() {
      if (this.source === 'server') {
        return this.serverData.rows;
      } else {
        return this.defaultData;
      }
    },
    tableTotal() {
      if (this.source === 'server') {
        return this.serverData.total;
      } else {
        return this.tableData.length;
      }
    },
    paginationParam() {
      if (this.pagination) {
        let params = {
          total: this.tableTotal,
          showSizeChanger: this.paginationShowSizeChanger,
          pageSizeOptions: this.pageSizeOption,
          pageSize: this.pageSize,
          current: this.pageNumber,
          showQuickJumper: this.paginationShowQuickJumper,
          size: 'default',
        };
        if(this.paginationShowTotal){
          params.showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} item`
        }
        return params;
      } else {
        return false;
      }
    },
    finalColumns(){
      if(this.serverType === 'DotNet' && this.dotNetColumns){
        return this.innerColumns;
      }else{
        return this.columns;
      }
    },
  },
  watch: {},
  methods: {
    query: function () {
      this.pageNumber = this.defaultPageNumber;
      this.load();
    },
    load: function () {
      if (this.source === 'server') {
        this.loadingFlag = true;
        if(this.serverType === 'NodeJs'){
          this.loadNodeJs().finally(() => this.loadingFlag = false);
        }else{
          this.loadDotNet().finally(() => this.loadingFlag = false);
        }
      } else {

      }
    },
    loadNodeJs(){
      let url = this.url;
      let queryParams = {};
      if (this.pagination) {
        queryParams.pageNumber = this.pageNumber - 1;
        queryParams.pageSize = this.pageSize;
      }
      if (this.pageSorter){
        queryParams.sortField = this.pageSorter.field;
        queryParams.sortOrder = this.pageSorter.order;
      }
      queryParams = Object.assign(queryParams, this.queryParams);

      let sendData = {};
      if(this.queryProperties){
        if (this.queryData) {
          this.queryData.properties = this.queryProperties;
          sendData = this.queryData;
        } else {
          sendData = {
            properties: this.queryProperties || {}
          }
        }
      }else{
        sendData = this.queryData;
      }

      return this.$ajax({
        url: url,
        method: this.method,
        data: sendData,
        params: queryParams,
        pathData: this.queryPathData,
      }).then(data => {
        this.serverData = data;
      });
    },
    loadDotNet(){
      let sendData = this.queryData;
      if(this.dotNetTableType === 3){ //复杂sql
        sendData = [ this.$dotNetUtil.commonReportJson(this.dotNetTableName, sendData, this.pageNumber, this.pageSize, this.dotNetDefaultSortField, this.dotNetTableType) ];
      }else if(this.dotNetTableType === 4){ // 组件外部处理格式
        let SORT_FIELD ='';
        let sort;
        if (this.pageSorter) {
          if (this.pageSorter.order === 'ascend') {
            sort = 'ASC'
          } else if (this.pageSorter.order === 'descend') {
            sort = 'DESC'
          } else {
            sort = ''
          }
          if(!this.pageSorter.field) {
            SORT_FIELD = ''
          } else {
            SORT_FIELD = this.pageSorter.field + ' ' + sort
          }
        }
        sendData = [{...this.queryData, PAGE_SIZE: this.pageSize, PAGE_INDEX: this.pageNumber, SORT_FIELD}];
      }else{
        if(this.pagination && this.paginationType === 'server'){ //分页查询
          sendData = [ this.$dotNetUtil.commonPageJson(this.dotNetTableName, sendData, this.pageNumber, this.pageSize, this.dotNetDefaultSortField, this.dotNetTableType) ];
        }else{ //普通查询，表名或sql
          sendData = [ this.$dotNetUtil.commonQueryJson(this.dotNetTableName, sendData, this.dotNetTableType) ];
        }
      }
      return this.$h5Api({
        type: this.dotNetQueryType,
        data: sendData,
        showMessage: false,
      }).then(({data, total}) => {
        if(this.dotNetTableType === 4){
          total = total ? total : data?.[this.dotNetReturnListField]?.length;
        }
        if(this.dotNetColumns){
          this.innerColumns = data['FILE_LIST'].map(c => ({ dataIndex: c['FIELD_NAME'], title: c['FIELD_NAME'] }));
        }
        if(this.pagination && this.paginationType === 'server'){
          if(this.dotNetReturnListField){
            this.serverData = {rows: data[this.dotNetReturnListField], total: total};
          }else{
            this.serverData = {rows: data, total: total};
          }
        }else{
          if(this.dotNetReturnListField){
            this.serverData = {rows: data[this.dotNetReturnListField], total: data[this.dotNetReturnListField].length};
          }else{
            this.serverData = {rows: data, total: data.length};
          }
        }
      }).catch(e => {
        if(!e['code'] || e['code'] !== "4"){
          this.$error({
            title: this.$t('sysMessage'),
            content: this.$t(e.status)
          });
        }else{
          this.serverData = {rows: [], total: 0};
        }
      });
    },
    appendData: function ({rows}) {
      this.tableData = this.tableData.concat(rows);
    },

    //继承原事件
    //--------------------
    handleTableChange(pagination, filters, sorter) {
      this.pageSize = pagination.pageSize;
      this.pageNumber = pagination.current;

      if(this.paginationType === 'server'){
        if(sorter){
          this.pageSorter = sorter
        }
        this.load();
      }
    },
    handelExpandedRowsChange(expandedRows){
      this.$emit('expandedRowsChange', expandedRows);
    },
    handelExpand(expanded, record){
      this.$emit('expand', expanded, record);
    },

    //--------------------
    operation_detail(record) {
      this.$emit('detail', record);
    },
    operation_edit(record) {
      this.$emit('edit', record);
    },
    operation_removeOne(id, record) {
      this.$emit('removeOne', id, record);
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.$emit('update:selectedRowKeys', selectedRowKeys);
      this.$emit('update:selectedRows', selectedRows);
      this.$emit('checkedChange', selectedRowKeys, selectedRows);
    },
  },

  created() {
    if (this.source === 'server') {
      if (this.initDataFlag) {
        this.query();
      }
    }
  },
  render(createElement) {
    let card = {
      name: 'dol-card',
      param: {
        class: 'dolphin-list',
        props: {
          title: this.title,
          titleFlag: this.titleFlag,
          cardFlag: this.cardFlag,
          cardClass: this.cardClass,
        }
      },
      children: [
        createElement('template', {slot: 'extra'}, this.$slots.extra),
        createElement('template', {slot: 'queryForm'}, this.$slots.queryForm),
      ]
    };
    let tableProps = {
      dataSource: this.tableData,
      rowKey: this.rowKey,
      loading: this.loadingFlag,
      showHeader: this.showHeader,
      size: this.size,
      locale: {
        emptyText:this.$t('emptyData')
      },
      bordered: this.bordered,
      pagination: this.paginationParam,
      defaultExpandAllRows: this.defaultExpandAllRows,
      customRow: (record) => {
        let props;
        if(this.customRow){
          props = this.customRow(record);
        }else{
          props = {
            on: {
              click: event => {
                this.$emit('row-click', record);
              }
            }
          }
        }
        return props
      }
    };
    if (this.scroll) {
      tableProps.scroll = this.scroll;
    } else if (this.scrollX || this.scrollY) {
      tableProps.scroll = {};
      if (this.scrollX) tableProps.scroll.x = this.scrollX;
      if (this.scrollY) tableProps.scroll.y = this.scrollY;
    }
    if(this.selectedRowKeys){
      tableProps.rowSelection = {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
      if(this.selectionGetCheckboxProps){
        tableProps.rowSelection.getCheckboxProps = this.selectionGetCheckboxProps;
      }
      if(this.selectionType){
        tableProps.rowSelection.type = this.selectionType;
      }
    }
    if(this.rowIndex){
      tableProps.columns = [{align: 'center', width: '35px', title: '#', scopedSlots: { customRender: 'rowIndex' }}].concat(this.finalColumns);
    }else{
      tableProps.columns = this.finalColumns;
    }

    let table = {
      name: 'a-table',
      param: {
        props: tableProps,
        on: {
          change: this.handleTableChange,
          expandedRowsChange: this.handelExpandedRowsChange,
          expand:this.handelExpand,
        },
        scopedSlots: {
          rowIndex: (field, record, index) => {
            return createElement('span', {}, index + 1);
          },
          YYYYMMDD: field => {
            return field ? createElement('span', {}, this.$moment(field).format('YYYY-MM-DD')) : '';
          },
          array: field => {
            let itemList = [];
            field.forEach((item) => {
              itemList.push(createElement('a-tag', {props:{color: 'blue'}}, item.name || item));
            });

            return createElement('span', {}, itemList);
          },
          operation: (field, record, index) => {
            let buttonList = [];
            if(!this.hideDetailButton){
              buttonList.push(createElement('dol-button', {
                props: {title: '查看', shape: 'circle', size: 'small'},
                on:{click:() => { event && event.stopPropagation(); this.operation_detail(record)}}
              }, [createElement('a-icon', {props: {type: 'search'}})]));
            }

            if(!this.hideEditButton){
              buttonList.push(createElement('dol-button', {
                props: {title: '修改', shape: 'circle', size: 'small'},
                on:{click:() => { event && event.stopPropagation(); this.operation_edit(record)}}
              }, [createElement('a-icon', {props: {type: 'edit'}})]));
            }

            if(!this.hideDeleteButton){
              buttonList.push(createElement('dol-button', {
                props: {title: '删除', shape: 'circle', size: 'small'},
                on:{click:() => { event && event.stopPropagation(); this.operation_removeOne(record[this.rowKey])}}
              }, [createElement('a-icon', {props: {type: 'delete'}})]));
            }

            return createElement('a-space', {}, buttonList);
          },
          dict: (field, record, index) => {
            let label;
            for(let key in record){
              if(record.hasOwnProperty(key) && record[key] === field){
                label = key;
                break;
              }
            }
            return createElement('dol-dict', {props:{code: label, option: field}});
          },
          fileSize: field => {
            return createElement('span', this.$Dolphin.getFileSize(field));
          },
          publicPath: (field, record) => {
            return createElement('span', [
              createElement('dol-button', {
                props: {title: '下载', shape: 'circle', size: 'small'},
                on:{click:() => {this.$Dolphin.download(record.name, this.$Dolphin.path.publicPath + field)}}
              }, [createElement('a-icon', {props: {type: 'download'}})]),
              ' ',
              createElement('dol-button', {
                props: {title: '复制链接', shape: 'circle', size: 'small'},
                on:{click:() => {this.$Dolphin.copy(location.origin + this.$Dolphin.path.publicPath + field)}}
              }, [createElement('a-icon', {props: {type: 'copy'}})]),
            ]);
          },
          password: (field) => {
            return createElement('span', field.replace(/./g, '*'));
          },
          html: (field) => {
            return createElement('span', {domProps: {innerHTML: field}});
          },
          pre: (field) => {
            return createElement('pre', field);
          },
          boolean: (field) => {
            return createElement('dol-boolean', {props: {value: field}});
          },
          percent: (field) => {
            return createElement('span', field?field + '%':'');
          },
          number: (field) => {
            return createElement('div', {style: {textAlign: 'right'}}, field);
          },
          wordBreakAll: (field) => {
            return createElement('span', {class: 'word-break-all'}, field);
          },
          address: (field) => {
            let address = '';
            field && field.forEach((f,i) => {
              if(i > 0){
                address += ' / ';
              }
              address += f.name;
            });

            return createElement('span', address);
          },
          objectEach: (field) => {
            let children = [];
            if(field && typeof field === 'object'){
              for(let key in field){
                children.push(createElement('div', `${key} = ${field[key]}`));
              }
            }

            return createElement('span', children);
          },
          iosDate: (field) => {
            return field ? this.$moment(field).format('YYYY-MM-DD') : '';
          },
          iosDatetime: (field) => {
            return field ? this.$moment(field).format('YYYY-MM-DD HH:mm:ss') : '';
          },
          codeShow: (field) => {
            return createElement('show-code', {props: {value: field}});
          },
        },
      },
      children: []
    };
    for(let customerScopedSlot in this.$scopedSlots){
      table.param.scopedSlots[customerScopedSlot] = this.$scopedSlots[customerScopedSlot];
    }
    for(let customerSlot in this.$slots){
      if(customerSlot !== 'extra' && customerSlot !== 'queryForm'){
        table.children.push(createElement('span', {slot:customerSlot}, this.$slots[customerSlot]));
      }
    }

    card.children.push(createElement(table.name, table.param, table.children));

    return createElement(card.name, card.param, card.children);
  }
}
</script>

<style lang="scss">
.dolphin-list{
  .ant-card-body{
    .ant-form + .ant-table-wrapper{
      margin-top: 10px;
    }
  }
}
</style>
